import { useSelector } from 'react-redux';

import { hostedVideoSelectors } from '../../../store/modules/hostedVideo';
import useProjectData from '../useProjectData';

const useDefaultPreview = (projectId?: string, initPreview?: string) => {
  const videoPoster = useSelector(hostedVideoSelectors.selectPoster);
  const { projectPreview } = useProjectData(projectId);
  const hostedPoster = useSelector(hostedVideoSelectors.selectPoster);

  const defaultPreview = initPreview || videoPoster?.posterUrl || projectPreview || hostedPoster?.posterUrl || '';

  return defaultPreview;
};

export default useDefaultPreview;
